









import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class SkeletonBlock extends Vue {
  @Prop({ default: 'div' })
  readonly tag: string

  @Prop({ default: null })
  readonly width: string | null

  @Prop({ default: null })
  readonly height: string | null

  @Prop({ default: null })
  readonly borderRadius: string | null

  get styleObject(): Record<string, string> {
    const styleObject: Record<string, string> = {}

    if (this.width) {
      styleObject.width = this.width
    }

    if (this.height) {
      styleObject.height = this.height
    }

    if (this.borderRadius) {
      styleObject.borderRadius = this.borderRadius
    }

    return styleObject
  }
}
